import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HardcopyactivityAuditTrialComponent } from './hardcopyactivity-audit-trial/hardcopyactivity-audit-trial.component';
import { HardcopyactivityAuditLifeCycleComponent } from './hardcopyactivity-audit-life-cycle/hardcopyactivity-audit-life-cycle.component';
import { HardcopyactivityAuditSummaryComponent } from './hardcopyactivity-audit-summary/hardcopyactivity-audit-summary.component';
import {FieldsetModule} from 'primeng/fieldset';
import { HardcopyactivityAuditModalComponent } from './hardcopyactivity-audit-modal/hardcopyactivity-audit-modal.component';
import { DialogModule } from 'primeng/dialog';
import { SharedModule } from '../shared/shared.module';
import { BptProgressSpinnerModule } from 'bpt-ui-library/bpt-progress-spinner';
import { ToastModule } from 'primeng/toast';
import { SpinnerComponent } from "../shared-components/spinner/spinner.component";
@NgModule({
  declarations: [
    HardcopyactivityAuditTrialComponent,
    HardcopyactivityAuditLifeCycleComponent,
    HardcopyactivityAuditSummaryComponent,
    HardcopyactivityAuditModalComponent
  ],
  imports: [
    CommonModule,
    FieldsetModule,
    DialogModule,
    SharedModule,
    ToastModule,
    BptProgressSpinnerModule,
    SpinnerComponent
],
  exports:[
    HardcopyactivityAuditModalComponent
  ]
})
export class HardcopyactivityAuditTrialModule { }
